var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-justify-end tw-ml-10",class:{'tw-text-red-500': _vm.timeRunningOut}},[_c('i',{staticClass:"fa fa-clock tw-pr-2"}),_vm._v(" "+_vm._s(_vm.timer)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }